import type { StateCreator } from 'zustand';
import type {
  PreferencesState,
  StrategiesDashboardViewMode,
} from '../types/preferencesStoreTypes';

export const createStrategiesDashboardViewModeSLice: StateCreator<
  PreferencesState,
  [],
  [],
  StrategiesDashboardViewMode
> = (set) => ({
  viewMode: 'grid',
  setViewMode: (mode) => set({ viewMode: mode }),
});
